// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../node_modules/css-loader/dist/cjs.js??ref--8-oneOf-3-1!../../../../../node_modules/postcss-loader/src/index.js??ref--8-oneOf-3-2!../../../../../node_modules/postcss-loader/src/index.js??ref--8-oneOf-3-3!../../../../../node_modules/sass-loader/dist/cjs.js??ref--8-oneOf-3-4!./custom.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("3c16baa8", content, true, {"sourceMap":false,"shadowMode":false});